var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M7.382 10.029L5.529 6.529",
    transform: "translate(-376 -49) translate(376 49)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.235 9.059c0 .682-.553 1.235-1.235 1.235S5.765 9.741 5.765 9.06 6.318 7.824 7 7.824s1.235.553 1.235 1.235z",
    transform: "translate(-376 -49) translate(376 49) translate(1 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M0 7L1.647 7M14 7L12.353 7M13.062 3.5L11.636 4.324M10.5.938L9.676 2.364M7 0L7 1.647M3.5.938L4.324 2.364M.938 3.5L2.364 4.324M11.28 9.47l1.781 1.03C13.658 9.47 14 8.276 14 7c0-3.866-3.134-7-7-7S0 3.134 0 7c0 1.276.342 2.47.939 3.5L2.72 9.47",
    transform: "translate(-376 -49) translate(376 49) translate(1 2.5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuManage);
export default __webpack_public_path__ + "static/media/ico16MenuManage.9b46ae43.svg";
export { ForwardRef as ReactComponent };